(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/loader-panel.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/loader-panel.js');
'use strict';

const LoaderPanel = () => {
  const loaderRef = React.useRef();
  React.useEffect(() => {
    const loader = new svs.ui.Loader(loaderRef.current, {
      delayedShow: false
    }).show(300);
    return () => loader.hide();
  });
  return React.createElement("div", {
    className: "relative align-center margin-top-4",
    "data-testid": "loader",
    ref: loaderRef
  });
};
svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.LoaderPanel = LoaderPanel;

 })(window);